
















import {Component, Vue} from 'vue-property-decorator';
import VueError from '@/components/VueError.vue';
import NavBar from '@/components/NavBar.vue';
import NavBarRouter from '@/components/NavBarRouter.vue';
import {curPref} from '@/services/Preferences';
import {DateTime} from 'luxon';


@Component({
  components: {
    VueError,
    NavBar,
    NavBarRouter,
  },
})
export default class Ntag extends Vue {
  curSection:'tags'|'locations' = curPref.retrieve('v3-ntag-cur-section', 'tags');
  error:string = '';

  routes = [
    {path: 'tags', label:'tags'},
    {path: 'locations', label:'locations'},
  ]

  // our model
  dateTime = DateTime;

  async mounted() {
    // nothing to do yet
  }

  navbarClickHandler(newSection:'tags'|'locations') {
    curPref.store('v3-ntag-cur-section', newSection);
    this.$router.push(`/applications/ntag/${newSection}`)
    this.curSection = newSection;
  }
}
